// extracted by mini-css-extract-plugin
export var deliveryRow = "_pz-a";
export var fixedHeight = "_pz-4";
export var freightLogo = "_pz-9";
export var fullWidth = "_pz-3";
export var priceColumn = "_pz-5";
export var radioSelected = "_pz-7";
export var radioUnselected = "_pz-6";
export var selectedOption = "_pz-2";
export var selectedOptionContainer = "_pz-1";
export var selection = "_pz-0";
export var tallSkeletonText = "_pz-8";